import React, { ReactElement }  from 'react';
import { components } from 'common';
import { lang } from '@umu/ukit-lang';
import TipsDialog from '../tipsDialog/tipsDialog';
import guildImg from '../../images/file_download_guide.png';

const { CustomDialog } = components;
const title: string = lang('温馨提示');
const confirmText: string = lang('知道了');
const content: ReactElement = (
    <div>
        {lang('由于文件较大，正在后台生成中，请前往【消息中心】-【系统消息】下载。本弹窗可以关闭。')}
        <img src={guildImg} alt="" width="100%" style={{ marginTop: '0.1rem' }} />
    </div>
);

function AsyncDownloadFileDialog(){
    return CustomDialog({
        className: 'connect-us-dialog',
        canClose: true,
        width: '450px',
        childProps: {
            title,
            content,
            showConfirm: true,
            confirmText,
            confirmClick: () => {
                console.log();
            },
        },
        contentComponent: TipsDialog,
    });
};

export default AsyncDownloadFileDialog;
